import { createFileRoute } from '@tanstack/react-router'

import { redirectToWebPath } from '@/lib/web-url'

export const Route = createFileRoute('/esqueci-senha')({
  beforeLoad: () => {
    redirectToWebPath('/esqueci-senha')
  },
})
